module.exports = __webpack_public_path__ + "img/mondomenu.0fa365fe.png";